import * as tslib_1 from "tslib";
import { AuthToken } from "../common/common.types";
import { HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { LogManager } from "../../common/log/log.manager";
import { LogCat } from "../../common/log/log.categories";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../common/app-config/app-configuration.service";
import * as i3 from "./auth-provider.service";
import * as i4 from "./patient.service";
import * as i5 from "../../common/intl/services/intl.service";
import * as i6 from "./patient.account.preferences.service";
var LoginInternalService = /** @class */ (function () {
    function LoginInternalService(httpClient, configService, tokenProvider, patientService, intlService, patientAccountPreferencesService) {
        this.httpClient = httpClient;
        this.configService = configService;
        this.tokenProvider = tokenProvider;
        this.patientService = patientService;
        this.intlService = intlService;
        this.patientAccountPreferencesService = patientAccountPreferencesService;
    }
    LoginInternalService.prototype.login = function (username, password) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config, clientId, clientSecret, base64ClientIdentifier, xmlRequestParam, reqSpec, patientSubj, identity_1, userLang;
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        config = this.configService.Config;
                        clientId = config.AuthDataParam.clientId;
                        clientSecret = config.AuthDataParam.clientSecret;
                        base64ClientIdentifier = btoa(clientId + ':' + clientSecret);
                        xmlRequestParam = encodeURIComponent('userName') + '=' +
                            encodeURIComponent(username) + '&' +
                            encodeURIComponent("password") + '=' + encodeURIComponent(password) + '&' +
                            encodeURIComponent("grant_type") + '=' + encodeURIComponent("password");
                        reqSpec = {
                            headers: new HttpHeaders((_a = {},
                                _a["withCredentials"] = "true",
                                _a["Authorization"] = 'Basic ' + base64ClientIdentifier,
                                _a["Content-Type"] = 'application/x-www-form-urlencoded;charset=utf-8',
                                _a))
                        };
                        return [4 /*yield*/, this.httpClient.post(config.AuthServerUrl + '/OAuth/PatientPortalInternalAuth', xmlRequestParam, reqSpec)
                                .pipe(map(function (token) {
                                if (token && token.access_token) {
                                    return _this.tokenProvider.setCredentials(token);
                                }
                                return null;
                            })).toPromise()];
                    case 1:
                        patientSubj = _b.sent();
                        if (!patientSubj) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.patientService.getPatientDetails().toPromise()];
                    case 2:
                        identity_1 = _b.sent();
                        // If this is the first user login, currently selected system language will be set as user's default language
                        if (identity_1.accountPreferences.defaultLanguageKey === 0 && this.intlService.usedLanguage) {
                            this.patientAccountPreferencesService.setDefaultAccountLanguage(this.intlService.usedLanguage.languageKey);
                        }
                        else if (identity_1.accountPreferences.defaultLanguageKey !== this.intlService.usedLanguage.languageKey) {
                            // If the system language was changed before login and it is different from user's default language - user language will be updated
                            if (this.intlService.defaultBrowserLanguage && this.intlService.usedLanguage &&
                                this.intlService.defaultBrowserLanguage.languageKey !== this.intlService.usedLanguage.languageKey) {
                                this.patientAccountPreferencesService.setDefaultAccountLanguage(this.intlService.usedLanguage.languageKey);
                            }
                            else {
                                userLang = this.intlService.cachedLanguages.find(function (l) { return l.languageKey === identity_1.accountPreferences.defaultLanguageKey; });
                                if (userLang) {
                                    this.intlService.setLanguage(userLang, true);
                                }
                            }
                        }
                        patientSubj.next(identity_1);
                        LogManager.debug(LogCat.Login.ExternalLogin, "login succeeded for patient - " + identity_1);
                        return [2 /*return*/, true];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    LoginInternalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoginInternalService_Factory() { return new LoginInternalService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AppConfigurationService), i0.ɵɵinject(i3.AuthProviderService), i0.ɵɵinject(i4.PatientService), i0.ɵɵinject(i5.IntlServicePP), i0.ɵɵinject(i6.PatientAccountPreferencesService)); }, token: LoginInternalService, providedIn: "root" });
    return LoginInternalService;
}());
export { LoginInternalService };
